var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SelectComponent',_vm._b({staticClass:"filter-select",attrs:{"value":_vm.valueComp,"empty-label":_vm.$t('select') + '...'},on:{"input":$ev => _vm.$emit('input', $ev)}},'SelectComponent',_vm.$attrs.options,false))
}
var staticRenderFns = []

export { render, staticRenderFns }